import React from 'react';

export default function ListHeading(params) {
  return (
    <h3 className={`list-heading mb-2 ${params.className ?? ''}`}>
      {params.children}
    </h3>
  );
}
